import { GET_PUBLIC_CONSULTATIONS } from '../../constants/ActionTypes';

const initialState = {
  loading: false,
  loaded: false,
  error: null,
  items: [],
  total: 0,
  limit: 100,
  abertas: [],
  encerradas: [],
  counts: {
    abertas: 0,
    encerradas: 0,
  },
  lastRequestParams: {
    limit: 100,
    filtro_orgao: 'no',
  },
};

export default function public_consultations(
  state = initialState,
  action = {},
) {
  switch (action.type) {
    case `${GET_PUBLIC_CONSULTATIONS}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
        lastRequestParams: {
          ...state.lastRequestParams,
          ...(action.request?.params || {}),
        },
      };

    case `${GET_PUBLIC_CONSULTATIONS}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        ...action.result,
        items: action.result?.items || [],
        total: action.result?.total || 0,
        limit: action.result?.limit || state.lastRequestParams?.limit || 100,
        abertas: action.result?.abertas || [],
        encerradas: action.result?.encerradas || [],
        counts: action.result?.counts || {
          abertas: 0,
          encerradas: 0,
        },
      };

    case `${GET_PUBLIC_CONSULTATIONS}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.error,
        items: [],
        total: 0,
        abertas: [],
        encerradas: [],
        counts: {
          abertas: 0,
          encerradas: 0,
        },
      };

    default:
      return state;
  }
}
